import {QueryValue} from "./types";

export const normalizeListValue = (value: QueryValue): string[] => {
    const values = Array.isArray(value) ? value : [value];

    return values
        .map((item) => normalizeScalarValue(item))
        .filter((item): item is string => Boolean(item))
        .sort((a, b) => a.localeCompare(b, undefined, {numeric: true}));
};

export const normalizeScalarValue = (value: QueryValue): string | null => {
    if (Array.isArray(value) || value == null || value === false || value === "") {
        return null;
    }

    return value.toString();
};
import {QueryValue} from "./types";

export const normalizeListValue = (value: QueryValue): string[] => {
    const values = Array.isArray(value) ? value : [value];

    return values
        .map((item) => normalizeScalarValue(item))
        .filter((item): item is string => Boolean(item))
        .sort((a, b) => a.localeCompare(b, undefined, {numeric: true}));
};

export const normalizeScalarValue = (value: QueryValue): string | null => {
    if (Array.isArray(value) || value == null || value === false || value === "") {
        return null;
    }

    return value.toString();
};
